"use client";

import { useFloatingContext } from "@faire/slate/private/floating/FloatingContext";
import { FloatingFocusManager, FloatingPortal } from "@floating-ui/react";
import React from "react";

export const MenuPortal: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { floatingRootContext, open } = useFloatingContext();

  if (!open) {
    return null;
  }

  return (
    <FloatingPortal>
      <FloatingFocusManager context={floatingRootContext} modal={false}>
        <>{children}</>
      </FloatingFocusManager>
    </FloatingPortal>
  );
};
